// Chart and data visualization components
import { defineAsyncComponent } from 'vue'

export default {
  ChartsMonthlyResults: defineAsyncComponent(
    () => import('../charts/monthly_results.vue')
  ),
  ChartsPowerPlantGeo: defineAsyncComponent(
    () => import('../charts/power_plant/geo.vue')
  ),
  ChartsPowerPlantHistory: defineAsyncComponent(
    () => import('../charts/power_plant/history.vue')
  ),
  ChartsPowerPlantLoad: defineAsyncComponent(
    () => import('../charts/power_plant/load.vue')
  ),
  ChartsPowerPlantMeasureTheorHourly: defineAsyncComponent(
    () => import('../charts/power_plant/measure_theor_hourly.vue')
  ),
  ChartsPowerPlantMeteogram: defineAsyncComponent(
    () => import('../charts/power_plant/meteogram.vue')
  ),
  ChartsPowerPlantMeteogramWind: defineAsyncComponent(
    () => import('../charts/power_plant/meteogram_wind.vue')
  ),
  ChartsPowerPlantPowerCurve: defineAsyncComponent(
    () => import('../charts/power_plant/power_curve.vue')
  ),
  ChartsPowerPlantRunoff: defineAsyncComponent(
    () => import('../charts/power_plant/runoff.vue')
  ),
  ChartsPowerPlantSolarKpiMonthly: defineAsyncComponent(
    () => import('../charts/power_plant/solar_kpi_monthly.vue')
  ),
  ChartsPowerPlantSpider: defineAsyncComponent(
    () => import('../charts/power_plant/spider.vue')
  ),
  ChartsPowerPlantWindKpiMonthly: defineAsyncComponent(
    () => import('../charts/power_plant/wind_kpi_monthly.vue')
  )
}
